import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { WarehouseItemSettingRead } from '../../entities/warehouse-item-setting.dto';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';

@Injectable()
export class WarehouseItemSettingStore extends AbstractEntityStore<WarehouseItemSettingRead> {
    constructor() {
        super(PFWmsEntities.WarehouseItemSetting);

        persistState(this._store, {
            storage: localStorageStrategy,
        });
    }
}
